<!--Main Grid-->
<div class="MainBorder">
	<!--Main Details-->
	<div class="MainGrid2Col">
		<label>Student ID:</label>
		<label class="InfoText">{{ StudentID }}</label>

		<label>Student Name:</label>
		<label class="InfoText">{{ StudentName }}</label>

		<label>Total Balance:</label>
		<label class="InfoText">{{ CurrentBalanceDesc }}</label>

		<label>Date/Time:</label>
		<label class="InfoText">{{ FineDT }}</label>

		<label>Transaction Type:</label>
		<label class="InfoText">{{ TransactionDesc }}</label>

		<label>Administrator:</label>
		<label class="InfoText">{{ AdminName }}</label>

		<label>Original Amount:</label>
		<label class="InfoText">{{ OriginalAmount }}</label>

		<label>Item Balance:</label>
		<label class="InfoText">{{ ItemBalance }}</label>

		<label>Comments:</label>
		<label class="InfoText">{{ Comments }}</label>
	</div>

	<!--Table-->
	<div class="DataTable" [style.width.px]="popup_WidthInt">
		<caass-fine-history-table [SelectedPerson]="SelectedPerson" [Fine]="SelectedFine"> </caass-fine-history-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
